(function(){
  function isProductPage(){
    return !!document.querySelector('.alessa-product-footer') || window.location.pathname.indexOf('/products/') === 0;
  }

  function hideLegacyFooters(){
    if(!isProductPage()) return;
    document.querySelectorAll('.blocky-footer').forEach(function(footer){
      if(footer.closest('.alessa-product-footer')) return;
      footer.style.setProperty('display','none','important');
      var wrapper = footer.closest('.shopify-section');
      if(wrapper) wrapper.style.setProperty('display','none','important');
    });
  }

  function run(){
    hideLegacyFooters();
    [0,50,150,300,600,1000,2000,4000].forEach(function(ms){ setTimeout(hideLegacyFooters, ms); });
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  new MutationObserver(hideLegacyFooters).observe(document.documentElement,{childList:true,subtree:true});
})();